import { TextField, styled } from "@mui/material"
import { GetTextFieldStyle } from "lib/styles/textField"
// Simplified and minimal style for FilterTextField
export const FilterTextField = styled(TextField)(() => ({ ...GetTextFieldStyle(), }))
